module.exports = __webpack_public_path__ + "assets/c612d5fc230bd4ad2c2563420ef82fec.png";